module.exports = __webpack_public_path__ + "img/btn_sy_zc_hd.58c00a7f.webp";